import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

// Super-admin renewal tracking for the three year agreements
// (improve-api Billing container, /billing/renewals). Direct only.
export default {
  getRenewals: function(params, search, status, sort) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/billing/renewals" + params + search + status + sort);
  },
  recordNotice: function(id, payload) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/billing/renewals/" + id + "/notice", payload);
  },
  withdrawNotice: function(id, note) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/billing/renewals/" + id + "/notice", {
      data: { note: note || null },
    });
  },
};
